export enum ToastType {
    'RELOAD' = 1,
    'HTTP_ERROR' = 2,
    'UNAVAILABLE' = 3,
    'REDIRECT' = 4,
    'SUCCESS' = 5,
    'WARNING' = 6
}
